import { useEffect, useState } from "react";
import { getLessonPlanFormOptions } from "../../../services/LessonPlanService";
import { useTeacherPrograms } from "../../../hooks/useTeacherPrograms";
import { toOptions } from "../utils/lessonPlanUtils";

/**
 * Classes (each with its subjects) the teacher can plan for, from
 * GET lesson-plan/form-options. Falls back to the teacher's subject mapping
 * if that endpoint returns no classes with subjects.
 */
export const useLessonPlanFormOptions = () => {
  const { programData: mappedPrograms } = useTeacherPrograms();
  const [formPrograms, setFormPrograms] = useState([]);

  useEffect(() => {
    let isCurrent = true;
    getLessonPlanFormOptions()
      .then((response) => {
        const data = response?.data?.data || {};
        const programs = toOptions(data.programs ?? data.classes).map((program) => ({
          ...program,
          subjects: toOptions(program.subjects),
        }));
        if (isCurrent) setFormPrograms(programs.filter((program) => program.subjects.length));
      })
      .catch((error) => console.error("lesson-plan/form-options failed, using subject mapping:", error));

    return () => {
      isCurrent = false;
    };
  }, []);

  return { programData: formPrograms.length ? formPrograms : mappedPrograms };
};
